import styled from 'styled-components';

export const PeriodSelect = styled.select`
  max-width: 310px;
`;
